<template>
  <div class="card mb-4">
    <div
      class="card-header d-flex justify-content-between align-items-center clickable-item"
      @click="collapsed = !collapsed"
    >
      <h5 class="mb-0">
        <i class="material-icons icon-16pt mr-1 align-middle">assessment</i>
        AI auto-grading
      </h5>
      <i class="material-icons">{{ collapsed ? 'expand_more' : 'expand_less' }}</i>
    </div>
    <b-collapse :visible="!collapsed">
      <div class="card-body">
        <div v-if="!isGraded" class="alert alert-warning mb-0" role="alert">
          <i class="material-icons icon-16pt mr-1">info</i>
          Enable <strong>"This is a graded assignment"</strong> above to configure AI auto-grading.
        </div>

        <div v-else>
          <!-- Toggles -->
          <b-form-group label-class="form-label" class="mb-2">
            <b-form-checkbox
              :checked="value.auto_grade_enabled"
              switch
              @change="updateField('auto_grade_enabled', $event)"
            >
              Enable AI auto-grading
            </b-form-checkbox>
            <small class="form-text text-muted">
              When ON, student submissions are graded automatically by AI. Each non-checkbox task must have a per-task
              rubric for accurate AI grading.
            </small>
          </b-form-group>

          <b-form-group label-class="form-label" class="mb-3">
            <b-form-checkbox
              :checked="value.human_review_required"
              switch
              :disabled="!value.auto_grade_enabled"
              @change="updateField('human_review_required', $event)"
            >
              Require human review before publishing
            </b-form-checkbox>
            <small class="form-text text-muted">
              When ON, the AI grade is saved as "In Review" for an admin to approve before the student sees it.
              Recommended while tuning rubrics.
            </small>
          </b-form-group>

          <!-- Context -->
          <b-form-group label="Scenario / business context" label-class="form-label">
            <b-form-textarea
              :value="value.auto_grade_context"
              @input="updateField('auto_grade_context', $event)"
              rows="3"
              placeholder="1–3 sentences describing the scenario the AI should keep in mind."
            />
          </b-form-group>

          <!-- Learning objectives -->
          <b-form-group label="Learning objectives" label-for="learning-objectives" label-class="form-label">
            <b-form-textarea
              id="learning-objectives"
              :value="value.learning_objectives"
              @input="updateField('learning_objectives', $event)"
              rows="6"
              class="monospace-textarea"
              placeholder="What this assignment is meant to teach. Bullet list style is fine."
            />
          </b-form-group>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export const AI_ASSIGNMENT_DEFAULTS = Object.freeze({
  auto_grade_enabled: false,
  human_review_required: false,
  auto_grade_context: '',
  learning_objectives: '',
});

export default {
  name: 'AssignmentAiSection',
  props: {
    value: { type: Object, required: true },
    isGraded: { type: Boolean, default: false },
  },
  data() {
    return {
      collapsed: !this.isGraded,
    };
  },
  watch: {
    isGraded(val) {
      if (!val && this.value.auto_grade_enabled) {
        // §2.3: force off when assignment becomes ungraded.
        this.updateField('auto_grade_enabled', false);
      }
      if (val) this.collapsed = false;
    },
    'value.auto_grade_enabled'(val) {
      if (!val && this.value.human_review_required) {
        this.updateField('human_review_required', false);
      }
    },
  },
  methods: {
    updateField(key, val) {
      this.$emit('input', { ...this.value, [key]: val });
    },
  },
};
</script>

<style scoped>
.monospace-textarea {
  font-family: ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, 'Liberation Mono', monospace;
  font-size: 0.85rem;
}
.clickable-item {
  cursor: pointer;
}
</style>
